
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/export-factoring/buyer-credit-check",
      function () {
        return require("private-next-pages/export-factoring/buyer-credit-check.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/export-factoring/buyer-credit-check"])
      });
    }
  